import TiposMutationCliente from "./tipos-mutation.cliente";
import {MapActionsCliente} from "./map-actions.cliente";
import ClienteModel from "@/models/cliente/cliente.model";

const cliente = {
    namespaced: true,
    state: () => ({
        clienteAtual: new ClienteModel(),
    }),
    mutations: {
        [TiposMutationCliente.SET_CLIENTE_ATUAL](state, payload) {
            state.clienteAtual = payload;
        }
    },
    actions: {
        [MapActionsCliente.SALVAR_CLIENTE_ATUAL]({commit, state}, clienteAtual) {
            commit(TiposMutationCliente.SET_CLIENTE_ATUAL, clienteAtual);
        },
    },
    getters: {
        id: state => {
            return state.clienteAtual.id;
        },
    }
}

export default cliente;
